const prepareShow = guest => {
  return guest
}

const prepareSave = guest => {
  return guest
}

export default {
  prepareSave,
  prepareShow,
  afterCreated () {
    this.$toast.success('Lista incluida com sucesso.')
    return this.$router.push({name: 'dweller.guest.index'})
  },
  afterUpdated () {
    this.$toast.success('Lista alterada com sucesso.')
    return this.$router.push({name: 'dweller.guest.index'})
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/guest/form/resources/methods.js